import { renderStatusCell } from 'ui/table/StatusCell';

export const DisputeStatusCell = renderStatusCell({
    won: 'green',
    needs_response: 'yellow',
    warning_needs_response: 'yellow',
    lost: 'red'
});
